export default "__VITE_ASSET__Begfsi0N__"